<template>
    <div>
    <app-toolbarcustom app_title="Form Entertainment" app_menu="employeeentertainment"></app-toolbarcustom>
        <template>
            <v-stepper v-model="steppers" class="mt-15 elevation-0">
              <v-stepper-header>
                <v-stepper-step
                  :complete="steppers > 1"
                  step="1"
                >
                  Form
                </v-stepper-step>
          
                <v-divider></v-divider>
          
                <v-stepper-step
                  :complete="steppers > 2"
                  step="2"
                >
                  Summary
                </v-stepper-step>
                
              </v-stepper-header>
          
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card
                    class="mb-12 elevation-0"
                  >
                  <v-form enctype="multipart/form-data" ref="form_entertainment_data" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" class="mt-2">
                        <app-cb
                        cb_type           ="todo"
                        cb_url            ="apiListTodo"
                        :cb_url_parameter  ="`todo_flag=expense&todo_cuser=${$functions.UsersID()}`"
                        cb_title          ="Todo"
                        cb_id             ="entertainment_todoid"
                        cb_desc           ="entertainment_tododesc"
                        cb_rules          ="Mohon isi Todo"
                        cb_desc_readonly  ="readonly"
                        cb_items_id       ="todo_id"
                        cb_items_desc     ="todo_desc"
                        cb_items_additional_1 ="todo_date"
                        :cb_value_id      ="form.entertainment_todoid"
                        :cb_value_desc    ="form.entertainment_tododesc"
                        cb_modul          ="entertainment"
                        @clicked          ="GetTodo"
                      >
                      </app-cb>
                    </v-col>
                    <template v-if="form.entertainment_tododesc">
                    <!-- ID -->
                    <v-col cols="12" sm="6" md="12" class="mt-n6">
                        <v-dialog
                        ref                 ="dialog_entertainment_sdate"
                        v-model             ="modal.entertainment_sdate"
                        :return-value.sync  ="form.entertainment_sdate"
                        width               ="290px"
                        persistent
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            :value              ="entertainment_sdate_value"
                            label               ="Periode Awal"
                            prepend-icon  ="event"
                            background-color    ="date"
                            v-on                ="on"
                            v-mask              ="'####-##-##'"
                            placeholder         ="YYYY-MM-DD"
                            id                  ="find_entertainment_sdate"
                            outlined
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="form.entertainment_sdate" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal.entertainment_sdate = false">Cancel</v-btn>
                        <v-btn
                            text
                            color   ="primary"
                            @click  ="GetData('entertainment_sdate',form.entertainment_sdate)"
                        >
                            OK
                        </v-btn>
                        </v-date-picker>
                    </v-dialog>
                    </v-col>
                    <!-- ID -->
                    <v-col cols="12" sm="6" md="12" class="mt-n6">
                        <v-dialog
                        ref                 ="dialog_entertainment_edate"
                        v-model             ="modal.entertainment_edate"
                        :return-value.sync  ="form.entertainment_edate"
                        width               ="290px"
                        persistent
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            :value              ="entertainment_edate_value"
                            label               ="Periode Akhir"
                            prepend-icon  ="event"
                            background-color    ="date"
                            v-on                ="on"
                            v-mask              ="'####-##-##'"
                            placeholder         ="YYYY-MM-DD"
                            id                  ="find_entertainment_edate"
                            outlined
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="form.entertainment_edate" :min="form.entertainment_sdate" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal.entertainment_edate = false">Cancel</v-btn>
                        <v-btn
                            text
                            color   ="primary"
                            @click  ="GetData('entertainment_edate',form.entertainment_edate)"
                        >
                            OK
                        </v-btn>
                        </v-date-picker>
                    </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-n6">
                        <app-cb
                        cb_type           ="code"
                        cb_url            ="apiListCode"
                        cb_url_parameter  ="code_actived=Y&code_group=ENTERTAINMENTTYPE"
                        cb_title          ="Tipe"
                        cb_id             ="entertainment_typeid"
                        cb_desc           ="entertainment_typeiddesc"
                        cb_rules          ="Mohon isi Tipe"
                        cb_desc_readonly  ="readonly"
                        cb_items_id       ="code_id"
                        cb_items_desc     ="code_desc"
                        :cb_value_id      ="form.entertainment_type"
                        :cb_value_desc    ="form.entertainment_typedesc"
                        @clicked          ="GetEntertainmentType"
                      >
                      </app-cb>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-n6">
                        <v-text-field 
                            v-model="form.entertainment_clientcompany"
                            :rules="form.entertainment_clientcompany_rules"
                            prepend-icon="notes"
                            placeholder="Nama Perusahaan Klien"
                            label="Nama Perusahaan Klien *"
                            required
                            solo-inverted
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-n6">
                        <v-text-field 
                            v-model="form.entertainment_clientname"
                            :rules="form.entertainment_clientname_rules"
                            prepend-icon="notes"
                            placeholder="Nama Klien(PIC)"
                            label="Nama Klien (PIC) *"
                            required
                            solo-inverted
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-n6">
                        <v-text-field 
                            v-model="form.entertainment_clientposition"
                            prepend-icon="notes"
                            placeholder="Jabatan Klien"
                            label="Jabatan Klien *"
                            required
                            solo-inverted
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-n6">
                        <v-text-field 
                            v-model="form.entertainment_clientbusiness"
                            prepend-icon="notes"
                            placeholder="Bidang Perusahaan"
                            label="Bidang Perusahaan *"
                            required
                            solo-inverted
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-n6">
                        <v-text-field 
                            v-model="form.entertainment_place"
                            :rules="form.entertainment_place_rules"
                            prepend-icon="location_on"
                            placeholder="Tempat"
                            label="Tempat *"
                            required
                            solo-inverted
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-n6">
                        <v-text-field 
                            v-model="form.entertainment_remarks"
                            :rules="form.entertainment_remarks_rules"
                            prepend-icon="notes"
                            placeholder="Berikan Catatan"
                            label="Catatan *"
                            required
                            solo-inverted
                            outlined
                        ></v-text-field>
                    </v-col>
                     <v-col cols="12" sm="12" md="12" class="mt-n6">
                            <vuetify-money
                                v-model         ="form.entertainment_total"
                                label           ="Total"
                                placeholder     ="Total"
                                :backgroundColor ="form.entertainment_type === 'P'?'readonly':'numeric'"
                                :options        ="format_amount"
                                :properties     ="properties"
                                :readonly       ="form.entertainment_type === 'P'?true:false"
                                required
                                solo-inverted
                                outlined
                            >
                            </vuetify-money>
                        </v-col>
                    </template>
                    </v-row> 
                    <v-alert
                    border="left"
                    colored-border
                    color="secondary"
                    elevation="2"
                    >
                    Saldo Bina Relasi <br>IDR {{$functions.NewFormatNumber(form.entertainment_balance)}} Limit Per Bulan: {{$functions.NewFormatNumber(form.entertainment_monthly)}}
                    </v-alert>
                    </v-form>
                  </v-card>
                  <br>
                  <v-btn
                    color="primary"
                    @click="NextStep(1)"
                    block
                    v-if="form.entertainment_tododesc"
                  >
                    Lanjut dan Upload Bukti
                  </v-btn>
          
                </v-stepper-content>
          
                <v-stepper-content step="2">
                  <v-card
                    class="mb-12"
                    outlined
                  >
                  <v-card-title class="body-2 font-weight-bold">Ringkasan Entertainment</v-card-title>

                    <v-card-text class="caption">
                            <v-row align="center">
                                <v-col cols="6">Todo</v-col><v-col cols="6" class="font-weight-bold">{{ form.entertainment_tododesc }} ({{$functions.FormatDateIndoWithDayName(form.entertainment_tododate)}})</v-col>
                                <v-col cols="6" class="mt-n5">Periode Awal</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ $functions.FormatDateIndoWithDayName(form.entertainment_sdate) }}</v-col>
                                <v-col cols="6" class="mt-n5">Periode Akhir</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ $functions.FormatDateIndoWithDayName(form.entertainment_edate) }}</v-col>
                                <v-col cols="6" class="mt-n5">Tipe</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.entertainment_typedesc }}</v-col>
                                <v-col cols="6" class="mt-n5">Nama Perusahaan</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.entertainment_clientcompany }}</v-col>
                                <v-col cols="6" class="mt-n5">Nama Klien</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.entertainment_clientname }}</v-col>
                                <v-col cols="6" class="mt-n5">Jabatan</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.entertainment_clientposition }}</v-col>
                                <v-col cols="6" class="mt-n5">Bidang Perusahaan</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.entertainment_clientbusiness }}</v-col>
                                <v-col cols="6" class="mt-n5">Tempat</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.entertainment_place }}</v-col>
                                <v-col cols="6" class="mt-n5">Catatan</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.entertainment_remarks }}</v-col>
                                <v-col cols="6" class="mt-n5 body-1 font-weight-bold">Total</v-col><v-col cols="6" class="mt-n5 text-right font-weight-bold green--text body-1">{{ $functions.NewFormatNumber(form.entertainment_total) }}</v-col>
                            </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-subheader class="body-2 font-weight-bold">Lampiran <v-spacer></v-spacer><span @click="UploadAttach()"><small><u>Upload Ulang</u></small></span></v-subheader>
                    <div class="primary--text font-weight-black" v-if="form.uploadinfo !== ''">Filename : {{form.uploadinfo}}</div>
                    <v-img :src="upload.src"></v-img>
                 </v-card>
          
                  <v-btn
                    color="primary"
                    @click="Confirm('add')"
                    block
                    class="mb-2"
                  >
                    Proses
                  </v-btn>
          
                  <v-btn color="secondary" @click="steppers = 1" block>
                    Sebelumnya
                  </v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
          <v-dialog v-model="confirm.dialog" max-width="490" persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{confirm.title}}</v-card-title>
                <v-card-text>
                    {{confirm.text}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" outlined @click.stop="confirm.dialog = false">{{confirm.close}}</v-btn>
                    <v-btn id="dialog_confirm_true" color="primary" outlined :disabled = "confirm.ok !== 'OK' ? true:false" @click="Loading">{{confirm.ok}}</v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="upload.dialog" max-width="490">
            <v-card>
                <v-card-title class="primary headline white--text">{{upload.title}}</v-card-title>
                <v-card-text>
                    <v-progress-linear
                    indeterminate
                    color="fourth"
                    rounded
                    v-if="loading.upload"
                    ></v-progress-linear>
                    <div class="primary--text font-weight-black" v-if="form.uploadinfo !== ''">Filename : {{form.uploadinfo}}</div>
                    <v-img :src="upload.src"></v-img>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green" outlined :disabled="upload.ok !== 'OK'?true:false" @click="Upload" v-if="form.uploadattach !== ''">{{upload.ok}}</v-btn>
                    <v-btn color="red" outlined @click="DeleteAttach" v-if="form.uploadattach !== ''">{{upload.delete}}</v-btn>
                    <input type="file" ref="attachment" @change="UploadAttachment" style="display:none">
                    <!-- <v-btn id="dialog_confirm_true" color="primary" outlined :disabled = "upload.ok !== 'OK' ? true:false" @click="WriteTodo('result')">{{upload.ok}}</v-btn> -->
                </v-card-actions>
        </v-card>
        </v-dialog>
          <app-snackbar 
            :dialog="snackbar.dialog"
            :color="snackbar.color"
            :text="snackbar.text"
            :timeout="snackbar.timeout"
            @close="snackbar.dialog = false"
          ></app-snackbar>
    </div>
</template>
<script>
    import imageCompression from 'browser-image-compression'
    export default {
        data: () => ({
            steppers: 1,
            url_type: 'add',
            current_date: '',
            form: {
                entertainment_todoid: '',
                entertainment_tododesc: '',
                entertainment_tododate: '',
                entertainment_sdate: new Date().toISOString().substr(0, 10),
                entertainment_sdate_rules: [v => !!v || 'Mohon isi Tanggal Awal'],
                entertainment_edate: new Date().toISOString().substr(0, 10),
                entertainment_edate_rules: [v => !!v || 'Mohon isi Tanggal Selesai'],
                entertainment_usersid: '',
                entertainment_type: 'M',
                entertainment_typedesc: 'MAKAN DAN MINUM',
                entertainment_place: '',
                entertainment_place_rules: [v => !!v || 'Mohon isi Nama Tempat'],
                entertainment_clientcompany: '',
                entertainment_clientcompany_rules: [v => !!v || 'Mohon isi Nama Perusahaan'],
                entertainment_clientname: '',
                entertainment_clientname_rules: [v => !!v || 'Mohon isi Nama Klien(PIC)'],
                entertainment_clientposition: '',
                entertainment_clientposition_rules: [v => !!v || 'Mohon isi Jabatan'],
                entertainment_clientbusiness: '',
                entertainment_clientbusiness_rules: [v => !!v || 'Mohon isi Bidang Perusahaan'],
                entertainment_remarks: '',
                entertainment_remarks_rules: [v => !!v || 'Mohon masukkan catatan'],
                entertainment_parking: 0,
                entertainment_fuel: 0,
                entertainment_toll: 0,
                entertainment_total: 0,
                entertainment_balance: 0,
                entertainment_monthly: 0,
                entertainment_attachment: '',
                uploadinfo: '',
                uploadattach: '',
            },
            modal: {
                entertainment_sdate: false,
                entertainment_edate: false,
            },
            loading: {
                upload: false
            },
            upload: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
                upload: 'Upload',
                delete: 'Hapus',
                src: '',
                target: '',
            },
            confirm: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
            },
            snackbar: {
                dialog: false,
                timeout: 3000,
                text: '',
                color: 'error'
            },
            format_amount: {
                locale: "id-ID",
                prefix: "",
                suffix: "",
                length: 15,
                precision: 0
            },
            // Format Properties
            properties: {
                reverse: true,
                'prepend-icon':'money'
            },
        }),
         // Check If Back Button Press, Modal Close
        beforeRouteLeave (to, from, next) {
            if (this.modal.entertainment_sdate || this.modal.entertainment_edate) {
                this.modal.entertainment_sdate = false
                this.modal.entertainment_edate = false
                next(false)
            } else {
                next()
            }
        },
        computed: {
            entertainment_sdate_value () {
                return this.form.entertainment_sdate ? this.$moment(this.form.entertainment_sdate).format('LL') : ''
            },
            entertainment_edate_value () {
                return this.form.entertainment_edate ? this.$moment(this.form.entertainment_edate).format('LL') : ''
            }
        },
        created() {
            this.Budget()
            this.form.entertainment_usersid = this.$functions.UsersID()
            if (this.$route.params.id !== undefined) {
                let decode = this.$functions.DecodeUrl(this.$route.params.id)
                // Pecah string berdasarkan "&" untuk memisahkan setiap pasangan kunci-nilai
                const pairs = decode.split('|');

                // Buat objek untuk menyimpan hasilnya
                const result = {};
                    // Loop melalui setiap pasangan kunci-nilai
                    pairs.forEach(pair => {
                    const [key, value] = pair.split('='); // Pecah pasangan menjadi kunci dan nilai
                    result[key] = value; // Simpan ke dalam objek
                });
                this.form.entertainment_todoid = result.todo_id
                this.form.entertainment_tododesc = result.todo_desc
                this.form.entertainment_tododate = result.todo_date
                this.form.entertainment_sdate = result.todo_date
                this.form.entertainment_edate = result.todo_date
            }
        },
        methods: {
            GoTo (url) {
               this.$router.push(url)
            },
            Confirm (flag) {
                if (flag === 'add') {
                    this.url_type = flag
                    this.confirm.dialog   = true
                    this.confirm.title    = 'Proses'
                    setTimeout(function(){
                    document.getElementById('dialog_confirm_true').focus()
                    }, 500)
                }
            },
            Loading () {
                this.confirm.ok = 'Loading...'
                if (this.url_type === 'add' || this.url_type === 'edit') {
                    this.Write()
                }
            },
            Write () {
                let formdata = {
                  url_type: this.url_type,
                  entertainment_todoid: this.form.entertainment_todoid,
                  entertainment_tododesc: this.form.entertainment_tododesc,
                  entertainment_tododate: this.form.entertainment_tododate,
                  entertainment_type: this.form.entertainment_type,
                  entertainment_sdate: this.form.entertainment_sdate,
                  entertainment_edate: this.form.entertainment_edate,
                  entertainment_clientcompany: this.form.entertainment_clientcompany,
                  entertainment_clientname: this.form.entertainment_clientname,
                  entertainment_clientposition: this.form.entertainment_clientposition,
                  entertainment_clientbusiness: this.form.entertainment_clientbusiness,
                  entertainment_place: this.form.entertainment_place,
                  entertainment_remarks: this.form.entertainment_remarks,
                  entertainment_total: this.$functions.ConvNom(this.form.entertainment_total),
                  entertainment_usersid: this.$functions.UsersID(),
                  entertainment_attachment  : this.upload.src,
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiWriteEntertainment'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            this.SnackBar(true, 'success', 'Proses Sukses', 3000)
                            this.confirm.dialog  	 = false
                            this.confirm.text 	 	 = 'Ok'
                            let encodeurl = this.$functions.EncodeUrl(feedback[0].feedback_id)
                            this.$router.push({name: 'employeeentertainmentdetail',params:{id:encodeurl}})
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 0)
                        }
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                })
            },
            GetData (flag, value) {
                switch (flag) {
                	case 'entertainment_sdate':
                		this.$refs.dialog_entertainment_sdate.save(value)
                        this.form.entertainment_sdate = this.$moment(value).format('YYYY-MM-DD')
                    break
                    case 'entertainment_edate':
                		this.$refs.dialog_entertainment_edate.save(value)
                        this.form.entertainment_edate = this.$moment(value).format('YYYY-MM-DD')
                    break
                }
            },
            NextStep(id) {
                if (id === 1) {
                    let validation = ''
                    let sdate = this.$functions.GetMonth(this.form.entertainment_sdate)
                    let edate = this.$functions.GetMonth(this.form.entertainment_edate)
                    if (sdate !== edate) {
                        validation = 'Mohon Masukkan Periode dalam Bulan yang sama'
                    } else if (this.form.entertainment_type === '') {
                        validation = 'Mohon isi Tipe'
                    } else if (this.form.entertainment_clientname === '') {
                        validation = 'Mohon isi Nama Klien'
                    } else if (this.form.entertainment_clientcompany === '') {
                        validation = 'Mohon isi Nama Perusahaan'
                    } else if (this.form.entertainment_place === '') {
                        validation = 'Mohon isi Tempat'
                    } else if (this.form.entertainment_total === 0) {
                        validation = 'Mohon isi Biaya'
                    } else if (this.form.entertainment_remarks === '') {
                        validation = 'Mohon isi Catatan'
                    }
                    if (validation !== '') {
                        this.SnackBar(true, 'error', validation, 0)
                    } else {
                        if ((this.form.entertainment_balance * 1) < (this.form.entertainment_total * 1)) {
                            this.SnackBar(true, 'error', 'Total tidak bisa lebih dari '+this.$functions.NewFormatNumber(this.form.entertainment_balance), 0)
                        }
                        //  else if ((this.form.entertainment_monthly * 1) < (this.form.entertainment_total * 1)) {
                        //     this.SnackBar(true, 'error', 'Total tidak bisa lebih dari Limit Per Bulan '+this.$functions.NewFormatNumber(this.form.entertainment_monthly), 0)
                        // } 
                        else {
                            if (this.form.uploadattach === '') {
                                this.UploadAttach()
                            } else {
                                this.steppers = 2
                            }
                        }
                    }
                }
            },
            GetTodo (value) {
                if (value !== undefined) {    
                    let splits  = this.$functions.Split(value, '|')
                    this.form.entertainment_todoid = splits[0]
                    this.form.entertainment_tododesc = splits[1]
                    this.form.entertainment_tododate = splits[3]
                    this.form.entertainment_sdate = splits[3]
                    this.form.entertainment_edate = splits[3]
                    this.form.entertainment_remarks = splits[1]
                }
            },
            GetEntertainmentType (value) {
                if (value !== undefined) {    
                    let splits  = this.$functions.Split(value, '|')
                    this.form.entertainment_type = splits[0]
                    this.form.entertainment_typedesc = splits[1]
                    this.form.entertainment_total = 0
                }
            },
            GetTotal() {
                let parking = this.form.entertainment_parking * 1
                let fuel = this.form.entertainment_fuel * 1
                let toll = this.form.entertainment_toll * 1
                let total    = parking + fuel + toll
                this.form.entertainment_total = total
            },
            Upload () {
                if (this.form.uploadattach === '') {
                    this.SnackBar(true, 'error', 'Mohon Upload Bukti', 3000)
                } else {
                    this.upload.dialog = false
                    this.steppers = 2
                }
            },
            UploadAttach () {
                this.upload.dialog = true
                let data = this
                setTimeout(function(){
                    data.$refs.attachment.click()
                }, 500)
            },
            DeleteAttach () {
                this.upload.src = ''
                this.form.uploadinfo = ''
                this.form.uploadattach = ''
                let data = this
                setTimeout(function(){
                    data.$refs.attachment.click()
                }, 500)
            },
            UploadAttachment () {
                var input = event.target
                if (input.files && input.files[0]) {
                    this.loading.upload = true
                    var filename = input.files[0].name
                    var extension = filename.split('.').pop().toLowerCase()
                    if (extension === 'jpeg' || extension === 'jpg' || extension === 'png') {
                        var imageFile = input.files[0]
                        var options = {
                        maxSizeMB: 0.3,
                        maxWidthOrHeight: 1920,
                        useWebWorker: true
                        }
                        let data = this
                        imageCompression(imageFile, options)
                        .then(function (compressedFile) {
                            data.GetImages(compressedFile)
                            data.form.uploadinfo = ''
                            data.loading.upload = false
                        })
                        .catch(function (error) {
                            alert(error.message)
                            this.loading.upload = false
                        })
                    } else {
                        var reader = new FileReader()
                        reader.onload = (e) => {
                            this.upload.src = e.target.result
                            this.form.uploadinfo = filename
                        }
                        this.form.uploadattach = input.files[0]
                        reader.readAsDataURL(input.files[0])
                        this.loading.upload = false
                    }
                }
            },
            async GetImages (data) {
                let blobUrl = URL.createObjectURL(data)
                try {
                    // Fetch the Blob data using the Blob URL
                    const response = await fetch(blobUrl);
                    const blobData = await response.blob();

                    // Convert Blob data to Base64
                    const reader = new FileReader();
                    reader.onload = () => {
                    this.upload.src = reader.result;
                    };
                    reader.readAsDataURL(blobData); // Convert Blob to Base64
                } catch (error) {
                    console.error('Error converting Blob URL to Base64:', error);
                }
                this.form.uploadattach = data
            },
            Budget () {
                let formdata = {
                  usersbudget_year: this.form.usersbudget_year,
                  usersbudget_usersid: this.$functions.UsersID(),
                  usersbudget_modul: 'entertainment'
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListUsersBudget'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                           this.form.entertainment_balance = feedback[0].usersbudget_remaining
                           this.form.entertainment_monthly = feedback[0].usersbudget_monthly
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 3000)
                        }
                    } else {
                        this.SnackBar(true, 'error', 'Anda belum memiliki budget untuk Bina Relasi', 3000)
                    }
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                })
            },
            SnackBar (dialog, color, text, timeout) {
                this.snackbar = {
                    dialog: dialog,
                    color: color,
                    text: text,
                    timeout: timeout
                }
                if (color === 'error') {
                    this.confirm.dialog 	 = false
                    this.confirm.ok 	 	 = 'OK'
                }
            }
        }
    }
</script>